export const WIDGET_LOAD_ERROR = 'WIDGET_LOAD_ERROR';
export const WIDGET_LOADING = 'WIDGET_LOADING';
export const WIDGET_LOADED = 'WIDGET_LOADED';
export const WIDGET_HIDDEN = 'WIDGET_HIDDEN';

export const INITIAL_STATE = 'INITIAL_STATE';



// WEBPACK FOOTER //
// ./src/actions/widgetStates.js